import { Stack } from '@mui/material';

type Props = {
  logoUrl?: string;
  height: number;
  justifyContent?: string;
};

export default function AnimatedCosmLogo({ logoUrl, height, justifyContent = 'center' }: Props) {
  return (
    <Stack direction="row" spacing={1} sx={{ justifyContent, alignItems: 'center' }}>
      
        <svg
          width="130"
          height="16"
          viewBox="0 0 130 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_4457_763)">
            <path
              d="M0.419922 7.98C0.419922 3.24 3.05992 0.800003 9.21992 0.800003C14.8199 0.800003 17.6799 2.84 17.9599 7.06H13.4799C13.2199 5.28 11.8199 4.52 9.21992 4.52C5.85992 4.52 4.81992 5.82 4.81992 7.98C4.81992 10.16 5.87992 11.48 9.21992 11.48C11.8199 11.48 13.2199 10.7 13.4799 8.9H17.9599C17.6799 13.14 14.8199 15.2 9.21992 15.2C3.05992 15.2 0.419922 12.74 0.419922 7.98ZM16.5918 15L23.8518 8L16.5918 1H22.4918L26.9118 5.4L31.3518 1H37.2318L29.9918 8L37.2318 15H31.3518L26.9118 10.6L22.4918 15H16.5918Z"
              fill="white"
            />
            <path
              d="M50.5241 3.6H52.1921L47.2361 12H45.5561L40.6001 3.6H42.2681L46.3961 10.668L50.5241 3.6ZM54.7193 3.6V12H53.2793V3.6H54.7193ZM62.4049 3.6C64.6729 3.6 66.5809 4.944 66.5809 7.8C66.5809 10.656 64.6729 12 62.4049 12H56.4049V3.6H62.4049ZM61.6849 10.8C64.0369 10.8 65.1409 10.2 65.1409 7.8C65.1409 5.4 64.0369 4.8 61.6849 4.8H57.8449V10.8H61.6849ZM76.9067 4.8H69.4667V7.2H76.9067V8.4H69.4667V10.8H76.9067V12H68.0267V3.6H76.9067V4.8ZM83.3787 12.12C79.6827 12.12 78.0987 10.476 78.0987 7.788C78.0987 5.112 79.6827 3.48 83.3787 3.48C87.0627 3.48 88.6587 5.124 88.6587 7.788C88.6587 10.464 87.0627 12.12 83.3787 12.12ZM83.3787 10.92C85.9347 10.92 87.2187 10.116 87.2187 7.788C87.2187 5.472 85.9467 4.68 83.3787 4.68C80.8107 4.68 79.5387 5.46 79.5387 7.788C79.5387 10.128 80.8227 10.92 83.3787 10.92Z"
              fill="white"
            />
            <path
              d="M103.44 3.60001H104.88V12H103.44V8.40001H95.1602V12H93.7202V3.60001H95.1602V7.20001H103.44V3.60001ZM117.12 7.78801C117.12 10.704 115.524 12.12 111.84 12.12C108.144 12.12 106.56 10.716 106.56 7.78801V3.60001H108V7.78801C108 9.16801 108.324 10.92 111.84 10.92C115.356 10.92 115.68 9.15601 115.68 7.78801V3.60001H117.12V7.78801ZM127.962 7.53601C128.682 7.90801 129.102 8.54401 129.102 9.57601C129.102 11.016 128.274 12 126.366 12H118.686V3.60001H126.126C128.034 3.60001 128.622 4.64401 128.622 5.85601C128.622 6.49201 128.406 7.09201 127.962 7.53601ZM120.126 4.80001V7.15201H125.766H125.778C126.558 7.15201 127.182 7.15201 127.182 5.97601C127.182 4.80001 126.558 4.80001 125.766 4.80001H120.126ZM126.246 10.8C127.038 10.8 127.662 10.8 127.662 9.57601C127.662 8.35201 127.038 8.35201 126.246 8.35201H120.126V10.8H126.246Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_4457_763">
              <rect width="130" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
     
      <div
        style={{
          width: '1px',
          height: `${height}px`,
          backgroundColor: '#CBCBD2',
          marginLeft: '16px',
          marginRight: '4px',
        }}
      />

      <div
        style={{
          height: `${height}px`,
          minWidth: `${height}px`,
        }}
      >
        {logoUrl && (
          <img
            src={logoUrl}
            alt="Organization Logo"
            style={{
              height: `${height}px`,
              width: 'auto',
            }}
          />
        )}
      </div>
    </Stack>
  );
}
